{
  "version": 1,
  "asset_id": "a1019b6d-c943-4356-bde9-8a3de059563e",
  "project_id": "6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb",
  "url": "/__l5e/assets-v1/a1019b6d-c943-4356-bde9-8a3de059563e/taper-fade-v1-1.webp",
  "r2_key": "a/v1/6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb/a1019b6d-c943-4356-bde9-8a3de059563e/taper-fade-v1-1.webp",
  "original_filename": "taper-fade-v1-1.webp",
  "size": 68174,
  "content_type": "image/webp",
  "created_at": "2026-09-09T09:54:33Z"
}
